import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { IOuter } from '../EmptyState.types';

export const SearchTitle: FC<IOuter> = () => <FormattedMessage id="empty-state.search-title-new" />;
